import React from "react";
import { Grid } from "@material-ui/core";
import './cardStyle.css'

const DashboardCard = (props) => {
  return (
        <Grid
            xs={12}
            sm={6}
            md={3}
            className="mt-4"
        >
            <div className="px-3">
                <div className="p-3" style={{backgroundColor: '#21242e'}}>
                    <div className="QMF---DashboardCard p-4 mx-auto">
                        <h2 className="text-uppercase px-lg-4">{props.title}</h2>
                    </div>
                    <div>
                    <h4 className="text-center text-light mt-4 mb-0">{props.detailstitle}</h4>
                        <h4 className="text-center  mb-0" style={{color: '#fea73e'}}>{props.details}</h4>
                    </div>
                </div>
            </div>
        </Grid>
  );
}

export default DashboardCard;
